export const DEFAULT_CLIPBOARD_CLEAR_TIMEOUT_MS = 30000;

export const copyTextToClipboard = async (text, timeoutMs = DEFAULT_CLIPBOARD_CLEAR_TIMEOUT_MS) => {
  await navigator.clipboard.writeText(text);

  if (timeoutMs > 0) {
    window.setTimeout(() => {
      navigator.clipboard.writeText('').catch(() => {});
    }, timeoutMs);
  }
};
